import React from 'react'
import NavBar from '../navbar/NavBar';
import Logo from './Logo';
// import Test from "../navbar/Test";


const SideBar = () => {
  return (
    <>
    <div className="leftCol">
        <Logo/>
        <NavBar/>
    </div>
    </>
  )
}

export default SideBar;